// Geometry for the clock-face focus timer (ClockDial). Pure: angles in degrees clockwise from 12.

/** Degrees clockwise from 12 for a minute position (0..60) on the dial. */
export const minuteDeg = (m: number) => (m / 60) * 360;

export function polar(c: number, r: number, deg: number): [number, number] {
  const rad = (deg * Math.PI) / 180;
  return [c + r * Math.sin(rad), c - r * Math.cos(rad)];
}

/** An arc path from `start` degrees, `sweep` degrees clockwise (a full ring at 360). */
export function arcPath(c: number, r: number, start: number, sweep: number): string {
  const s = Math.max(0, Math.min(360, sweep));
  if (s <= 0) return '';
  if (s >= 359.99) {
    const [x0, y0] = polar(c, r, start);
    const [x1, y1] = polar(c, r, start + 180);
    return `M ${x0} ${y0} A ${r} ${r} 0 1 1 ${x1} ${y1} A ${r} ${r} 0 1 1 ${x0} ${y0}`;
  }
  const [x0, y0] = polar(c, r, start);
  const [x1, y1] = polar(c, r, start + s);
  return `M ${x0} ${y0} A ${r} ${r} 0 ${s > 180 ? 1 : 0} 1 ${x1} ${y1}`;
}

/** Where the minute hand points, as a minute position 0..60 (seconds included). */
export function minuteOf(ts: number): number {
  const d = new Date(ts);
  return d.getMinutes() + d.getSeconds() / 60;
}

/** A drag at angle `pointerMinute` sets a length counted on from the minute hand, 1..60, never jumping across the hand. */
export function lengthAt(pointerMinute: number, handMinute: number, prev: number): number {
  let m = Math.round((((pointerMinute - handMinute) % 60) + 60) % 60);
  if (m === 0) m = prev > 30 ? 60 : 1;
  if (Math.abs(m - prev) > 30) m = prev > 30 ? 60 : 1;
  return m;
}
